import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "../../css/inner-page/sectionRetention.scss";
import CTA from "../CTA";

export default function Section(props) {
  return (
    <section id="retention">
      <div
        className="retention-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/outline-bg.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center bottom",
          backgroundSize: "cover",
        }}
      ></div>
      <div className="heading">
        <h2 dangerouslySetInnerHTML={{ __html: props.title }}></h2>
        <div className="subtitle-wrapper">
          <h3 data-aos="fade-up" dangerouslySetInnerHTML={{ __html: props.subtitle }}></h3>
        </div>
      </div>
      <div className="gallery-wrapper">
        <span data-aos="fade-up" className="gallery-background">
          OUR CUSTOMERS
        </span>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={100}
          slidesPerView={1.5}
          speed={10000}
          duration={10000}
          grabCursor={true}
          loop={true}
          autoplay={{
            delay: 1,
            disableOnInteraction: false,
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 200,
            },
            1920: {
              slidesPerView: 4,
              spaceBetween: 200,
            },
          }}
        >
          {props.brands.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <div className={`gallery-item gallery-template-${(index + 1) % 3 === 0 ? 3 : (index + 1) % 3}`}>
                  <div className="background">
                    <img src={item.background_image_group["1x"]} alt={item.background_image_group.alt} />
                  </div>
                  <div className="gallery-item-content">
                    <img src={item.logo_group["1x"]} alt={item.logo_group.alt} />
                    <p>{item.quote}</p>
                    <span dangerouslySetInnerHTML={{ __html: item.name_role }}></span>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className="asset-wrapper">
        <div className="img-wrapper">
          <img src={props.asset.image_group["1x"]} alt={props.asset.image_group.alt} />
        </div>
        <div className="content-wrapper">
          <span className="type">{props.asset.type}</span>
          <span className="title" dangerouslySetInnerHTML={{ __html: props.asset.title }} data-aos="fade"></span>
          <p data-aos="fade">{props.asset.content}</p>
          <CTA href={props.asset.cta.url} title={props.asset.cta.title} segmentLocation="Article Highlight" />
        </div>
      </div>
    </section>
  );
}
